import { useCallback } from 'react';
import {
  useFullState,
  useWriteContext,
} from '@/features/remotion-editor/editor/utils/use-context';

export const useMaskState = () => {
  const state = useFullState();
  const { setState } = useWriteContext();
  const mask = state.undoableState.mask;

  const setMaskEnabled = useCallback(
    (enabled: boolean) => {
      if (!mask) return;

      setState({
        update: (currentState) => {
          const currentMask = currentState.undoableState.mask;
          if (!currentMask || currentMask.enabled === enabled) {
            return currentState;
          }

          return {
            ...currentState,
            undoableState: {
              ...currentState.undoableState,
              mask: {
                ...currentMask,
                enabled,
              },
            },
          };
        },
        commitToUndoStack: true,
      });
    },
    [mask, setState],
  );

  return {
    mask,
    isMaskEnabled: Boolean(mask?.enabled),
    setMaskEnabled,
  };
};
